const mEditionBillingStudentTracking = {
  mEditionBillingStudentTracking: {
    alerts: {
      readAcademiaId: {
        error: 'No se encontró una academia con esa url. Revisa el dato ingresado.'
      },

      readTrackingAlumnos: {
        error: 'Un error ha ocurrido al cargar la trazabilidad. Vuelve a intentarlo en un momento.'
      },

      readTrackingAlumnosExportar: {
        error: 'Un error ha ocurrido al exportar. Vuelve a intentarlo en un momento.',
        success: 'El listado fue exportado exitosamente.'
      }
    },

    buttonPrimary: 'Exportar CSV',

    buttonSecondary: {
      filterText: 'Filtros'
    },

    files: {
      tracking: 'trazabilidad-alumnos'
    },

    filters: {
      completedAll: 'Progreso: todos',
      completedYes: 'Completados',
      completedNo: 'En curso',
      inactivityPlaceholder: 'sin actividad hace (días)',
      projectAll: 'Proyecto: todos'
    },

    labels: {
      accessActive: 'Acceso activo',
      accessInactive: 'Acceso inactivo',
      completed: 'Completado',
      current: 'Vigente',
      inProgress: 'En curso',
      never: 'Nunca',
      notCurrent: 'No vigente',
      progressActive: 'Activado:'
    },

    messages: {
      noData: 'No hay datos de trazabilidad para esta academia. Verificá que el backfill haya sido ejecutado.'
    },

    table: {
      thStudent: 'Alumno',
      thLastLogin: 'Último login',
      thProject: 'Proyecto',
      thLastAccess: 'Último ingreso',
      thLastSeen: 'Último visto',
      thProgress: 'Progreso',
      thState: 'Estado',
      thDetail: 'Detalle'
    },

    tooltip: {
      detail: 'Ver detalle del alumno',
      reload: 'Recargar listado'
    }
  },

  mEditionBillingStudentTrackingDetail: {
    alerts: {
      readTrackingResumen: {
        error: 'Un error ha ocurrido al cargar el resumen. Vuelve a intentarlo en un momento.'
      },

      readTrackingLogins: {
        error: 'Un error ha ocurrido al cargar los logins. Vuelve a intentarlo en un momento.'
      }
    },

    labels: {
      accessActive: 'Acceso activo',
      accessInactive: 'Acceso inactivo',
      completed: 'Completado',
      completedDate: 'Fecha completado',
      current: 'Vigente',
      email: 'Email',
      failure: 'Fallido',
      inProgress: 'En curso',
      ip: 'IP',
      lastAccess: 'Último ingreso al proyecto',
      lastLogin: 'Último login a la plataforma',
      lastSeen: 'Último visto',
      never: 'Nunca',
      noLogins: 'Este usuario no tiene logins registrados todavía.',
      noProjects: 'Este usuario no tiene inscripciones con trazabilidad todavía.',
      notCurrent: 'No vigente',
      origin: 'Origen',
      originClassroom: 'Acceso aula',
      originLogin: 'Login',
      progress: 'Progreso',
      progressActive: 'Activado:',
      success: 'Exitoso'
    },

    sections: {
      academies: 'Ingresos a academias (staff)',
      lastLogin: 'Último login',
      loginsHistory: 'Historial de logins',
      projects: 'Progreso por proyecto'
    },

    table: {
      academies: {
        thAcademy: 'Academia',
        thRole: 'Rol',
        thLastAccess: 'Último ingreso'
      },

      logins: {
        thDate: 'Fecha',
        thIp: 'IP',
        thOrigin: 'Origen',
        thDomain: 'Dominio',
        thResult: 'Resultado'
      },

      projects: {
        thProject: 'Proyecto',
        thCurrent: 'Inscripción',
        thLastAccess: 'Último ingreso',
        thLastSeen: 'Último visto',
        thProgress: 'Progreso',
        thState: 'Estado'
      }
    }
  }
}

export default mEditionBillingStudentTracking
